import SliderContainerWithArrowNavigation from "./SliderContainerWithArrowNavigation";

export default SliderContainerWithArrowNavigation;